/** @file Crossfade weight of a track entry over its from-entry: mixTime / mixDuration in [0, 1]. */
import { clamp } from '@pose2d/math/clamp';
import type { TrackEntry } from '../contracts/state';

/** 1 when the entry has no mix duration; otherwise clamp(mixTime / mixDuration, 0, 1). */
export function mixWeight(entry: TrackEntry): number {
  return entry.mixDuration <= 0 ? 1 : clamp(entry.mixTime / entry.mixDuration, 0, 1);
}
